module.exports = __webpack_public_path__ + "assets/img/22_242_big.db9861e3.jpg";